import React, { memo } from "react";

/**
 * Veliki, jedva primjetni krugovi u pozadini plavog panela (prijava, uvodi čarobnjaka) — daju dubinu plavoj podlozi,
 * a ne natječu se s karticama.
 */
const ShowcaseBackdrop: React.FC = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      <div className="absolute -top-40 -left-32 w-[30rem] h-[30rem] rounded-full bg-white/[0.04]" />
      <div className="absolute top-[30%] -right-48 w-[34rem] h-[34rem] rounded-full bg-white/[0.03]" />
      <div className="absolute -bottom-56 left-[10%] w-[36rem] h-[36rem] rounded-full bg-white/[0.04]" />
      <div className="absolute top-[12%] right-[18%] w-24 h-24 rounded-full bg-white/[0.05]" />
    </div>
  );
};

export default memo(ShowcaseBackdrop);
